import axios from 'axios'
import * as storage from './storage'

const graphqlClient = axios.create({
  baseURL: `${process.env.API_BASE_URL}/graphql`,
})

const buildNoCacheHeaders = () => ({
  Authorization: 'Bearer ' + storage.getItem('access_token'),
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Cache-Control': 'no-store',
  Pragma: 'no-cache',
  Expires: '0',
})

export const graphqlRequest = ({ query, variables = {}, config = {} }) => {
  if (!query) {
    throw new Error('graphqlRequest requires a query string')
  }

  const headers = {
    ...buildNoCacheHeaders(),
    ...(config.headers || {}),
  }

  const params = {
    cacheBust: Date.now(),
    ...(config.params || {}),
  }

  return graphqlClient.post(
    '',
    {
      query,
      variables,
    },
    {
      ...config,
      headers,
      params,
    }
  )
}

